module.exports = __webpack_public_path__ + "static/media/Country Club Dr, South San Francisco, CA1.9251be83.jpg";